import "../variables.module.css";

import classnames from "classnames";

import { TypeaheadKeyboardShortcutBanner } from "@mirage/education/TypeaheadKeyboardShortcutBanner";
import type { TypeaheadResult } from "@mirage/mosaics/SearchBarWithTypeahead/useConvertToTypeaheadResults";
import {
  showAddToStackShortcut,
  showCopyLinkShortcut,
  showNewShortcut,
  showSummarizeShortcut,
} from "@mirage/mosaics/SearchBarWithTypeahead/util/util";
import { useAtomValue } from "jotai";
import { ModeAtom } from "../../atoms/mode";
import { useOmniboxMotionFlag } from "../../hooks/useOmniboxMotion";
import style from "./DropdownBanner.module.css";

export const DropdownBanner = ({
  isDarwin,
  results,
  selectedIdx,
  isTypeaheadOpen,
  isBannerContentEnabled,
}: {
  isDarwin: boolean;
  results: TypeaheadResult[];
  selectedIdx: number;
  isTypeaheadOpen: boolean;
  isBannerContentEnabled: boolean;
}) => {
  const omniboxScopedMode = useAtomValue(ModeAtom);
  const { getMotionVersionFor } = useOmniboxMotionFlag();
  const expandMotionVersion = getMotionVersionFor("expand");

  const selectedResult = results[selectedIdx];

  return (
    <div
      className={classnames(style.dropdownBanner, {
        [style.isExpandMotionV1]: expandMotionVersion === "V1",
        [style.isTypeaheadOpen]: isTypeaheadOpen,
      })}
    >
      <TypeaheadKeyboardShortcutBanner
        isDarwin={isDarwin}
        isBannerContentEnabled={isBannerContentEnabled}
        showAddToStackShortcut={showAddToStackShortcut(selectedResult)}
        showSummarizeShortcut={showSummarizeShortcut(selectedResult)}
        showCopyLink={showCopyLinkShortcut(true, selectedResult)}
        showNewShortcut={showNewShortcut(true, omniboxScopedMode)}
      />
    </div>
  );
};
